var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.listingSearch && _vm.listingSearch.cancelled)?_c('div',{staticClass:"listing-search-empty-state mt-5",attrs:{"role":"status"}},[_c('p',{staticClass:"is-bolder"},[_vm._v(" Busca cancelada ")]),_c('p',[_vm._v("Ajuste os filtros e clique em Buscar.")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }